import * as React from "react";
import { HeaderContext } from "../helpers/header-provider/header-provider.mjs";
const Affix = (props) => {
  const { className, children } = props;
  const referenceElement = React.useRef(null);
  const [affixHeight, setAffixHeight] = React.useState(0);
  const [windowsHeight, setWindowsHeight] = React.useState(0);
  const { headerHeight, isHeaderHidden, headerBottomHeight } = React.useContext(HeaderContext);
  React.useEffect(() => {
    setAffixHeight(referenceElement.current ? referenceElement.current.clientHeight : 0);
  }, [referenceElement]);
  React.useEffect(() => {
    const resizeListener = () => {
      setWindowsHeight(window.innerHeight - headerHeight - (isHeaderHidden ? headerBottomHeight : 0));
    };
    window.addEventListener("resize", resizeListener);
    resizeListener();
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, [headerHeight, isHeaderHidden, headerBottomHeight]);
  const BEM = () => {
    const classArray = ["affix"];
    if (className) {
      classArray.push(className);
    }
    if (affixHeight > windowsHeight) {
      classArray.push("affix--static");
    }
    return classArray.join(" ");
  };
  const getStyle = () => {
    var _a;
    const inModal = (
      /* istanbul ignore next */
      ((_a = referenceElement == null ? void 0 : referenceElement.current) == null ? void 0 : _a.closest(".modal")) !== null
    );
    const top = headerHeight - (isHeaderHidden ? headerBottomHeight : 0);
    return {
      top: inModal ? 0 : top
    };
  };
  return /* @__PURE__ */ React.createElement("div", { ref: referenceElement, className: BEM(), style: getStyle(), "aria-hidden": props["aria-hidden"] }, children);
};
export {
  Affix
};
